import { UserRoles } from "common/enums";
import * as appRoutes from "config/routes.config";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import AnimatedPage from "utils/animatedPage";

const ParentRoute: FC = ({ children }) => {

    const navigate = useNavigate();
    const { isLoggedIn, user, isAppInMaintenance } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAppInMaintenance) {
            navigate(appRoutes.MAINTENANCE);
        };
    }, [isAppInMaintenance]);

    const isParent = user?.roles?.includes(UserRoles.PARENT);
    if (!isLoggedIn) return <Navigate to={appRoutes.HOME} />;
    if (isLoggedIn && !isParent) return <Navigate to={appRoutes.FORBIDDEN} />;

    return <AnimatedPage> {children} </AnimatedPage>;
};

export default ParentRoute;
